export const layout = {
  index: '/',
  kakaochannel: 'http://pf.kakao.com/_LZRdE',
  blog: 'https://blog.naver.com/jebs_jemm',
  youtube: 'https://www.youtube.com/@JEBS.official',
  instagram: 'https://www.instagram.com/jebs.official/',
};

// TODO: 어드민에서 관리하는 방식으로 변경
export const FREE_TRIAL_EXTERNAL_LINKS = {
  BLOG_REVIEW: 'https://blog.naver.com/jebs_jemm',
  PRIMARY_BLOG_REVIEW: 'https://blog.naver.com/jebs_jemm/224439189744',
  YOUTUBE_REVIEW: 'https://www.youtube.com/@JEBS.official',
  PRIMARY_YOUTUBE_REVIEW: 'https://youtu.be/kx4b8GMXVf8?si=MbGV1ro3t05PpCRa',
  SEMINAR_APPLY: 'https://forms.gle/hYg6Q4YQ4tMcBFb58',
  SEMINAR_VIDEO: 'https://www.youtube.com/watch?v=m4ShOqs_7To',
  KAKAO: 'https://pf.kakao.com/_LZRdE',
};
